import styled from '@emotion/styled';
import { ContentWrapper, fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Container = styled.div`
  background-color: #f7f7f8;
  padding: 52px 0 72px 0;

  @media screen and (max-width: 1350px) {
    form {
      padding: 20px 0px 52px 0;
    }
  }

  @media screen and (max-width: 850px) {
    padding: 24px 0 40px 0;

    form {
      padding: 0px 0px 20px 0;
    }
  }
`;

export const Wrapper = styled(ContentWrapper)`
  padding-top: 30px;
  button[type='button'] {
    margin-top: 56px;
  }
`;

export const Offers = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding-bottom: 56px;
`;

export const Offer = styled.div`
  background-color: #fff;
  height: 300px;
  padding: 24px;
  border-radius: 3px;
  box-shadow: 0 4px 4px 4px rgba(214, 214, 214, 0.2);
  min-width: 412px;
  flex: 1;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  position: relative;

  img {
    width: 20%;
    margin-bottom: auto;
  }

  & h3 {
    margin: 16px 0 24px;
  }

  &:nth-of-type(3n) {
    margin-right: 0;
  }

  &:last-of-type {
    flex: 0;
    width: 416px;
  }

  //Preloader
  & div {
    align-self: center;
    height: calc(100% - 20px);

    span {
      height: calc(100% - 20px) !important;
    }
  }

  @media only screen and (max-width: 1350px) {
    &:last-of-type {
      flex: 1;
      width: unset;
    }
  }

  @media only screen and ${breakpoint.sm} {
    min-width: unset;
    width: 100%;
    flex: 0;
  }
`;

export const TypeHeader = styled.h2`
  font-size: ${fontSize(14)};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: -0.2096px;
  text-transform: uppercase;
  color: ${({ type, theme }) => theme.colors.offers[type]};

  span {
    display: none;
  }

  &::after {
    content: '${(props) => (props.type === 'holiday_internship' ? 'holiday internship' : props.type)}';
  }
`;

export const TemporaryImage = styled.div`
  width: 40px;
  height: 40px;
  background-color: #005f88;
`;

export const CompanyName = styled.p`
  margin-top: 24px;
  font-size: ${fontSize(18)};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: -0.2704px;
  color: #00202d;
`;

export const ExpirationDate = styled.p`
  font-size: ${fontSize(12)};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: -0.1792px;
  text-align: right;
  color: #00405b;
`;

export const Filters = styled.form`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media only screen and ${breakpoint.lg} {
    flex-wrap: wrap;
    gap: 16px;
  }

  @media only screen and ${breakpoint.md} {
    display: block;
    box-shadow: ${({ theme }) => theme.shadow.medium};
  }

  .simple-dropdown__container {
    width: 500px;
  }
`;
